<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text" primary-title>{{
        options.item.action == 'add'
          ? $t('lbl.dataSource.sqlGroup.addD2DSqlGroupDialog.pageHeaderAdd')
          : $t('lbl.dataSource.sqlGroup.addD2DSqlGroupDialog.pageHeaderModify')
      }}</v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="dialog-container">
      <v-card-text class="pb-0">
        <v-form ref="form">
          <v-row class="ml-4 mr-4 data-section">
            <v-col cols="12" lg="6" class="pa-0">
              <v-row no-gutters style="height: 100%;">
                <v-col cols="12" lg="10" class="">
                  <v-row no-gutters class="mb-3">
                    <v-col cols="3">
                      <v-icon x-small>fas fa-asterisk</v-icon>
                      <span class="code-group-label">
                        {{ $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.sqlGroupName') }}</span
                      >
                    </v-col>
                    <v-col cols="9" class="pa-0">
                      <v-text-field
                        ref="sqlGroupName"
                        v-model="sqlGroupName"
                        class="data-table-filter-text-field custom-selectbox"
                        height="40"
                        hide-details
                        dense
                        solo
                        outlined
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters class="mb-0 code-table-grid sql-group-left">
                    <v-expansion-panels v-model="panel" multiple>
                      <v-col
                        cols="12"
                        class="pa-0 mb-2"
                        @click="onChangeSelectRadio('Select (Source)')"
                      >
                        <fieldset class="fieldset-item">
                          <legend class="pl-1 pr-4">
                            <div>
                              <input
                                type="radio"
                                class="mr-1"
                                name="matched-map"
                                @change="onChangeSelectRadio('Select (Source)')"
                                style="cursor: pointer;"
                                value="Select (Source)"
                                v-model="selectRadioItem"
                              />
                              Select (Source)
                            </div>
                            <div style="margin-top: -10px">
                              <v-icon
                                class="ml-4 mr-2"
                                small
                                @click="moveUpQuery"
                                :disabled="
                                  selectItemQuerySelect.length === 0 ||
                                    selectedItemIndexSelect === 0
                                "
                                :color="
                                  selectRadioItem === 'Select (Source)' ? '#5FCBFA' : '#7D838D'
                                "
                                >fas fa-caret-up</v-icon
                              >
                              <v-icon
                                class="ma-0"
                                small
                                @click="moveDownQuery"
                                :disabled="
                                  selectItemQuerySelect.length === 0 ||
                                    selectedItemIndexSelect === this.sqlGroupDataSelect.length - 1
                                "
                                :color="
                                  selectRadioItem === 'Select (Source)' ? '#5FCBFA' : '#7D838D'
                                "
                                >fas fa-caret-down</v-icon
                              >
                            </div>
                          </legend>
                          <v-expansion-panel
                            class="mt-0"
                            :style="
                              sqlGroupDataSelect.length > 0 ? 'display: block' : 'display: none'
                            "
                          >
                            <v-expansion-panel-header
                              class="pa-0"
                              v-if="selectRadioItem !== 'Select (Source)'"
                            >
                              <template v-slot:actions>
                                <v-icon style="display: none" class="icon">$expand</v-icon>
                              </template>
                              <v-list nav dense class="code-group-list py-0" :flat="true">
                                <v-list-item-group
                                  v-model="selectedItemIndexSelect"
                                  color="primary"
                                >
                                  <v-list-item
                                    v-for="(item, index) in sqlGroupDataSelect.slice(0, 2)"
                                    :key="index"
                                    @click="selectItemQuery(item)"
                                    class="mb-0 p-0"
                                  >
                                    <v-tooltip top style="z-index: 99">
                                      <template v-slot:activator="{ on }">
                                        <div v-on="on" class="btn-tooltip mr-0 mt-2">
                                          <v-list-item-icon class="mr-0" style="font-size: 16px">
                                            {{ index + 1 }}.
                                          </v-list-item-icon>
                                        </div>
                                      </template>
                                      <span
                                        v-html="
                                          $t(
                                            'lbl.dataSource.sqlGroup.addSqlGroupDialog.tooltipQuerySeq'
                                          )
                                        "
                                      ></span>
                                    </v-tooltip>
                                    <v-list-item-content class="mr-2">
                                      <a class="group-code-link" style="max-width: 118px">{{
                                        item.sql_cnt_nm
                                      }}</a>
                                    </v-list-item-content>
                                    <v-list-item-action style="flex-direction: row;">
                                      <v-select
                                        :items="srcTRG"
                                        v-model="src"
                                        disabled
                                        @click.stop
                                        :menu-props="{ offsetY: true }"
                                        class="data-table-filter-text-field search-button-data-analysis-table mr-2"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                      <v-select
                                        :items="sourceDbInstanceList"
                                        v-model="item.sql_db_instance"
                                        disabled
                                        :rules="[validationUtils.required]"
                                        @click.stop
                                        :menu-props="{ offsetY: true }"
                                        placeholder="DB Instance"
                                        class="data-table-filter-text-field search-button-data-analysis-table"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                    </v-list-item-action>
                                    <v-list-item-icon class="ml-2 mt-4">
                                      <v-icon x-small class="pa-2">fas fa-times</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content v-else>
                              <v-list nav dense class="code-group-list py-0" :flat="true">
                                <v-list-item-group
                                  v-model="selectedItemIndexSelect"
                                  color="primary"
                                >
                                  <v-list-item
                                    v-for="(item, index) in sqlGroupDataSelect"
                                    :key="index"
                                    @click="selectItemQuery(item)"
                                    class="mb-0 p-0"
                                  >
                                    <v-tooltip top style="z-index: 99">
                                      <template v-slot:activator="{ on }">
                                        <div v-on="on" class="btn-tooltip mr-0">
                                          <v-list-item-icon class="mr-0">
                                            {{ index + 1 }}.
                                          </v-list-item-icon>
                                        </div>
                                      </template>
                                      <span
                                        v-html="
                                          $t(
                                            'lbl.dataSource.sqlGroup.addSqlGroupDialog.tooltipQuerySeq'
                                          )
                                        "
                                      ></span>
                                    </v-tooltip>
                                    <v-list-item-content class="mr-2">
                                      <a class="group-code-link" style="max-width: 118px">{{
                                        item.sql_cnt_nm
                                      }}</a>
                                    </v-list-item-content>
                                    <v-list-item-action style="flex-direction: row;">
                                      <v-select
                                        :items="srcTRG"
                                        v-model="src"
                                        disabled
                                        @click.stop
                                        :menu-props="{ offsetY: true }"
                                        class="data-table-filter-text-field search-button-data-analysis-table mr-2"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                      <v-select
                                        :items="sourceDbInstanceList"
                                        v-model="item.sql_db_instance"
                                        :rules="[validationUtils.required]"
                                        @click.stop
                                        :menu-props="{ offsetY: true }"
                                        placeholder="DB Instance"
                                        class="data-table-filter-text-field search-button-data-analysis-table"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                    </v-list-item-action>
                                    <v-list-item-icon
                                      class="ml-2 mt-4"
                                      @click.stop="confirmDeleteItem(item)"
                                    >
                                      <v-icon x-small class="pa-2">fas fa-times</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </fieldset>
                      </v-col>
                      <v-col
                        cols="12"
                        class="pa-0 mb-2"
                        @click="onChangeSelectRadio('Execution (Target)')"
                      >
                        <fieldset class="fieldset-item">
                          <legend class="pl-1 pr-4">
                            <div>
                              <input
                                type="radio"
                                class="mr-1"
                                name="matched-map"
                                @change="onChangeSelectRadio('Execution (Target)')"
                                style="cursor: pointer;"
                                value="Execution (Target)"
                                v-model="selectRadioItem"
                              />
                              Execution (Target)
                            </div>
                            <div style="margin-top: -10px">
                              <v-icon
                                class="ml-4 mr-2"
                                small
                                @click="moveUpQuery"
                                :disabled="
                                  selectItemQueryExecution.length === 0 ||
                                    selectedItemIndexExecution === 0
                                "
                                :color="
                                  selectRadioItem === 'Execution (Target)' ? '#5FCBFA' : '#7D838D'
                                "
                                >fas fa-caret-up</v-icon
                              >
                              <v-icon
                                class="ma-0"
                                small
                                @click="moveDownQuery"
                                :disabled="
                                  selectItemQueryExecution.length === 0 ||
                                    selectedItemIndexExecution ===
                                      this.sqlGroupDataExecution.length - 1
                                "
                                :color="
                                  selectRadioItem === 'Execution (Target)' ? '#5FCBFA' : '#7D838D'
                                "
                                >fas fa-caret-down</v-icon
                              >
                            </div>
                          </legend>
                          <v-expansion-panel
                            class="mt-0"
                            :style="
                              sqlGroupDataExecution.length > 0 ? 'display: block' : 'display: none'
                            "
                          >
                            <v-expansion-panel-header
                              class="pa-0"
                              v-if="selectRadioItem !== 'Execution (Target)'"
                            >
                              <template v-slot:actions>
                                <v-icon style="display: none" class="icon">$expand</v-icon>
                              </template>
                              <v-list nav dense class="code-group-list py-0" :flat="true">
                                <v-list-item-group
                                  v-model="selectedItemIndexExecution"
                                  color="primary"
                                >
                                  <v-list-item
                                    v-for="(item, index) in sqlGroupDataExecution.slice(0, 2)"
                                    :key="index"
                                    @click="selectItemQuery(item)"
                                    class="mb-0 p-0"
                                  >
                                    <v-tooltip top style="z-index: 99">
                                      <template v-slot:activator="{ on }">
                                        <div
                                          v-on="on"
                                          class="btn-tooltip mr-0"
                                          style="margin-top: 10px"
                                        >
                                          <v-list-item-icon class="mr-0" style="font-size: 16px">
                                            {{ index + 1 }}.
                                          </v-list-item-icon>
                                        </div>
                                      </template>
                                      <span
                                        v-html="
                                          $t(
                                            'lbl.dataSource.sqlGroup.addSqlGroupDialog.tooltipQuerySeq'
                                          )
                                        "
                                      ></span>
                                    </v-tooltip>
                                    <v-list-item-content class="mr-2">
                                      <a class="group-code-link" style="max-width: 118px">{{
                                        item.sql_cnt_nm
                                      }}</a>
                                    </v-list-item-content>
                                    <v-list-item-action style="flex-direction: row;">
                                      <v-select
                                        :items="srcTRG"
                                        v-model="trg"
                                        disabled
                                        @click.stop
                                        :menu-props="{ offsetY: true }"
                                        class="data-table-filter-text-field search-button-data-analysis-table mr-2"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                      <v-select
                                        :items="targetDbInstanceList"
                                        v-model="item.sql_db_instance"
                                        disabled
                                        :rules="[validationUtils.required]"
                                        @click.stop
                                        :menu-props="{ offsetY: true }"
                                        placeholder="DB Instance"
                                        class="data-table-filter-text-field search-button-data-analysis-table"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                    </v-list-item-action>
                                    <v-list-item-icon class="ml-2 mt-4">
                                      <v-icon x-small class="pa-2">fas fa-times</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content v-else>
                              <v-list nav dense class="code-group-list pt-0" :flat="true">
                                <v-list-item-group
                                  v-model="selectedItemIndexExecution"
                                  color="primary"
                                >
                                  <v-list-item
                                    v-for="(item, index) in sqlGroupDataExecution"
                                    :key="index"
                                    @click="selectItemQuery(item)"
                                    class="mb-0 p-0"
                                  >
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <div v-on="on" class="btn-tooltip mr-0">
                                          <v-list-item-icon class="mr-0">
                                            {{ index + 1 }}.
                                          </v-list-item-icon>
                                        </div>
                                      </template>
                                      <span
                                        v-html="
                                          $t(
                                            'lbl.dataSource.sqlGroup.addSqlGroupDialog.tooltipQuerySeq'
                                          )
                                        "
                                      ></span>
                                    </v-tooltip>
                                    <v-list-item-content class="mr-2">
                                      <a class="group-code-link" style="max-width: 118px">{{
                                        item.sql_cnt_nm
                                      }}</a>
                                    </v-list-item-content>
                                    <v-list-item-action style="flex-direction: row;">
                                      <v-select
                                        :items="srcTRG"
                                        v-model="trg"
                                        disabled
                                        :menu-props="{ offsetY: true }"
                                        @click.stop
                                        class="data-table-filter-text-field search-button-data-analysis-table mr-2"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                      <v-select
                                        :items="targetDbInstanceList"
                                        v-model="item.sql_db_instance"
                                        :rules="[validationUtils.required]"
                                        :menu-props="{ offsetY: true }"
                                        @click.stop
                                        placeholder="DB Instance"
                                        class="data-table-filter-text-field search-button-data-analysis-table"
                                        style="width: 120px; z-index: 99"
                                        hide-details
                                        dense
                                        solo
                                      ></v-select>
                                    </v-list-item-action>
                                    <v-list-item-icon
                                      class="ml-2 mt-4"
                                      @click.stop="confirmDeleteItem(item)"
                                    >
                                      <v-icon x-small class="pa-2">fas fa-times</v-icon>
                                    </v-list-item-icon>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-list>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </fieldset>
                      </v-col>
                      <v-col cols="12" class="pa-0 mb-2">
                        <v-label>
                          Add Execution Result
                          <v-icon @click="addExecutionResult()" :disabled="!$auth.manage" dense dark
                            >mdi-plus</v-icon
                          >
                        </v-label>
                      </v-col>
                      <v-expansion-panels v-model="panelEx" multiple>
                        <v-col
                          cols="12"
                          class="pa-0 mb-2"
                          v-for="(executionResult, index) in executionResultList"
                          :key="index"
                          @click="onChangeSelectRadioExecution(index)"
                        >
                          <div class="text-right" style="height: 5px">
                            <v-icon
                              @click.stop="removeExecutionResult(index)"
                              :disabled="!$auth.manage"
                              dense
                              dark
                              >mdi-minus</v-icon
                            >
                          </div>
                          <fieldset class="fieldset-item">
                            <legend class="pl-1 pr-4">
                              <div class="d-flex">
                                <input
                                  type="radio"
                                  class="mr-1"
                                  name="matched-map"
                                  @change="onChangeSelectRadioExecution(index)"
                                  style="cursor: pointer;"
                                  :value="index"
                                  v-model="panelEx[0]"
                                />
                                <!-- Done -->
                                <v-select
                                  v-model="executionResult.sql_func_type"
                                  :items="executionTypeList"
                                  :rules="[validationUtils.required]"
                                  solo
                                  :disabled="!$auth.manage"
                                  style="width: 100px; z-index: 99"
                                  dense
                                  @change="onChangeSelectRadioExecution(index)"
                                  hide-details="true"
                                ></v-select>
                              </div>
                              <div style="margin-top: -10px">
                                <v-icon
                                  class="ml-4 mr-2"
                                  small
                                  @click="moveUpQueryEx(index)"
                                  :disabled="
                                    executionResult.selectItemQuery.length === 0 ||
                                      executionResult.selectedItemIndex === 0
                                  "
                                  :color="index === panelEx[0] ? '#5FCBFA' : '#7D838D'"
                                  >fas fa-caret-up</v-icon
                                >
                                <v-icon
                                  class="ma-0"
                                  small
                                  @click="moveDownQueryEx(index)"
                                  :disabled="
                                    executionResult.selectItemQuery.length === 0 ||
                                      executionResult.selectedItemIndex ===
                                        executionResult.sqlGroupData.length - 1
                                  "
                                  :color="index === panelEx[0] ? '#5FCBFA' : '#7D838D'"
                                  >fas fa-caret-down</v-icon
                                >
                              </div>
                            </legend>
                            <v-expansion-panel
                              class="mt-0"
                              :style="
                                executionResult.sqlGroupData.length > 0
                                  ? 'display: block'
                                  : 'display: none'
                              "
                            >
                              <v-expansion-panel-header class="pa-0" v-if="index !== panelEx[0]">
                                <template v-slot:actions>
                                  <v-icon style="display: none" class="icon">$expand</v-icon>
                                </template>
                                <v-list nav dense class="code-group-list py-0" :flat="true">
                                  <v-list-item-group
                                    v-model="executionResult.selectedItemIndex"
                                    color="primary"
                                  >
                                    <v-list-item
                                      v-for="(item, index) in executionResult.sqlGroupData.slice(
                                        0,
                                        2
                                      )"
                                      :key="index"
                                      @click="
                                        selectItemQueryEx(index, item),
                                          onChangeSelectRadioExecution(index)
                                      "
                                      class="mb-0 p-0"
                                    >
                                      <v-tooltip top style="z-index: 99">
                                        <template v-slot:activator="{ on }">
                                          <div
                                            v-on="on"
                                            class="btn-tooltip mr-0"
                                            style="margin-top: 10px"
                                          >
                                            <v-list-item-icon class="mr-0" style="font-size: 16px">
                                              {{ index + 1 }}.
                                            </v-list-item-icon>
                                          </div>
                                        </template>
                                        <span
                                          v-html="
                                            $t(
                                              'lbl.dataSource.sqlGroup.addSqlGroupDialog.tooltipQuerySeq'
                                            )
                                          "
                                        ></span>
                                      </v-tooltip>
                                      <v-list-item-content class="mr-2">
                                        <a class="group-code-link" style="max-width: 118px">{{
                                          item.sql_cnt_nm
                                        }}</a>
                                      </v-list-item-content>
                                      <v-list-item-action style="flex-direction: row;">
                                        <v-select
                                          :items="srcTRG"
                                          v-model="item.sql_src_trg_flag"
                                          disabled
                                          @click.stop
                                          :menu-props="{ offsetY: true }"
                                          class="data-table-filter-text-field search-button-data-analysis-table mr-2"
                                          style="width: 120px; z-index: 99"
                                          hide-details
                                          dense
                                          solo
                                        ></v-select>
                                        <v-select
                                          :items="dbInsType"
                                          v-model="item.sql_db_instance"
                                          disabled
                                          :rules="[validationUtils.required]"
                                          @click.stop
                                          :menu-props="{ offsetY: true }"
                                          placeholder="DB Instance"
                                          class="data-table-filter-text-field search-button-data-analysis-table"
                                          style="width: 120px; z-index: 99"
                                          hide-details
                                          dense
                                          solo
                                        ></v-select>
                                      </v-list-item-action>
                                      <v-list-item-icon class="ml-2 mt-4">
                                        <v-icon x-small class="pa-2">fas fa-times</v-icon>
                                      </v-list-item-icon>
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content v-else>
                                <v-list nav dense class="code-group-list pt-0" :flat="true">
                                  <v-list-item-group
                                    v-model="executionResult.selectedItemIndex"
                                    color="primary"
                                  >
                                    <v-list-item
                                      v-for="(item, i) in executionResult.sqlGroupData"
                                      :key="i"
                                      @click="
                                        selectItemQueryEx(index, item),
                                          onChangeSelectRadioExecution(index)
                                      "
                                      class="mb-0 p-0"
                                    >
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                          <div v-on="on" class="btn-tooltip mr-0">
                                            <v-list-item-icon class="mr-0">
                                              {{ i + 1 }}.
                                            </v-list-item-icon>
                                          </div>
                                        </template>
                                        <span
                                          v-html="
                                            $t(
                                              'lbl.dataSource.sqlGroup.addSqlGroupDialog.tooltipQuerySeq'
                                            )
                                          "
                                        ></span>
                                      </v-tooltip>
                                      <v-list-item-content class="mr-2">
                                        <a class="group-code-link" style="max-width: 118px">{{
                                          item.sql_cnt_nm
                                        }}</a>
                                      </v-list-item-content>
                                      <v-list-item-action style="flex-direction: row;">
                                        <v-select
                                          :items="srcTRG"
                                          v-model="item.sql_src_trg_flag"
                                          :rules="[validationUtils.required]"
                                          :menu-props="{ offsetY: true }"
                                          @click.stop
                                          placeholder="SRC/TRG"
                                          class="data-table-filter-text-field search-button-data-analysis-table mr-2"
                                          style="width: 120px; z-index: 99"
                                          hide-details
                                          dense
                                          solo
                                        ></v-select>
                                        <v-select
                                          :items="dbInsType"
                                          v-model="item.sql_db_instance"
                                          :rules="[validationUtils.required]"
                                          :menu-props="{ offsetY: true }"
                                          @click.stop
                                          placeholder="DB Instance"
                                          class="data-table-filter-text-field search-button-data-analysis-table"
                                          style="width: 120px; z-index: 99"
                                          hide-details
                                          dense
                                          solo
                                        ></v-select>
                                      </v-list-item-action>
                                      <v-list-item-icon
                                        class="ml-2 mt-4"
                                        @click.stop="confirmDeleteItemEx(index, item)"
                                      >
                                        <v-icon x-small class="pa-2">fas fa-times</v-icon>
                                      </v-list-item-icon>
                                    </v-list-item>
                                  </v-list-item-group>
                                </v-list>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </fieldset>
                        </v-col>
                      </v-expansion-panels>
                    </v-expansion-panels>
                  </v-row>
                </v-col>
                <v-col cols="12" lg="2" class="pt-0 pb-0 btn-add-code-row">
                  <v-btn
                    class="btn btn-top btn-search btn-add-code"
                    color="primary"
                    @click="addSQLGroup"
                    :disabled="isBtnActive"
                  >
                    <v-icon :size="20" class="mr-2 ml-2">fas fa-angle-double-left</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" class="code-table-grid">
              <v-row class="ma-0">
                <!-- [S]  second table-->
                <v-col cols="12" class="pa-0">
                  <v-row class="ma-0">
                    <v-col cols="3" class="pa-0 pr-2">
                      <v-text-field
                        v-model="searchBy.sql_cnt_nm"
                        :placeholder="
                          $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.conditionSearch.queryName')
                        "
                        @keyup.enter="getSQLGroupQueryInfoList"
                        class="data-table-filter-text-field search-button-data-analysis-table"
                        heigth="30"
                        outlined
                        hide-details
                        dense
                        solo
                      ></v-text-field>
                    </v-col>
                    <v-col cols="3" class="pa-0 pr-2">
                      <v-select
                        v-model="searchBy.sql_cnt_tp"
                        :items="types"
                        :menu-props="{ offsetY: true }"
                        label="Type"
                        @change="getSQLGroupQueryInfoList"
                        class="data-table-filter-text-field search-button-data-analysis-table label-peer-text3"
                        hide-details
                        dense
                      ></v-select>
                    </v-col>
                    <v-col cols="6" class="pa-0">
                      <v-text-field
                        v-model="searchBy.sql_cnt"
                        :placeholder="
                          $t('lbl.dataSource.sqlGroup.addSqlGroupDialog.conditionSearch.queryText')
                        "
                        @keyup.enter="getSQLGroupQueryInfoList"
                        class="data-table-filter-text-field search-button-data-analysis-table"
                        heigth="30"
                        outlined
                        hide-details
                        dense
                        solo
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0 pt-2">
                      <v-data-table
                        :search="searchCodeName"
                        :headers="headerSQLGroup"
                        :items="sqlGroupQueryInfoList"
                        :items-per-page="-1"
                        :hide-default-footer="true"
                        :disable-sort="false"
                        class="map-list-table code-list-data-table db-broker-data-table pb-0"
                        fixed-header
                      >
                        <template v-slot:header.checkbox>
                          <v-checkbox
                            v-model="checkedAll"
                            @change="selectAllChange"
                            class="select-checkbox-layout-table align-center justify-center"
                            color="#dbd7db"
                            dense
                            hide-details
                            :disabled="sqlGroupData.length === 0 || isDisabledAll"
                          ></v-checkbox>
                        </template>
                        <template v-slot:body="{ items }">
                          <tbody>
                            <tr
                              v-for="(item, index) in items"
                              :key="index"
                              :class="[
                                selectedRowLinked == item.sql_cnt_nm ||
                                (selectedRowLinked == '' && index == 0)
                                  ? 'selected_row'
                                  : '',
                              ]"
                            >
                              <td class="checkbox-col">
                                <v-checkbox
                                  v-model="item.checked"
                                  @click.native.stop
                                  @click.native="selectItemChange($event, item)"
                                  class="select-checkbox-layout-table align-center justify-center"
                                  color="#dbd7db"
                                  dense
                                  hide-details
                                  :disabled="item.disabled"
                                ></v-checkbox>
                              </td>
                              <td class="code-grp-col no-wrap">{{ item.sql_cnt_nm }}</td>
                              <td class="code-grp-col no-wrap custom-type-db">
                                {{ item.sql_cnt_tp }}
                              </td>
                              <td class="code-grp-col no-wrap">{{ item.sql_cnt }}</td>
                            </tr>
                          </tbody>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-col>
                <!-- [E]  second table-->
              </v-row>
            </v-col>
          </v-row>
          <v-row class="no-gutters btn-code-section">
            <v-col cols="12" lg="6" class="pa-0 text-right">
              <v-row no-gutters>
                <v-col cols="12" lg="10">
                  <v-btn
                    class="btn btn-popup-search btn-popup"
                    color="primary"
                    @click="saveSQLGroupName"
                  >
                    <!-- <v-icon x-small class="mr-2">fas fa-save</v-icon> -->
                    {{ $t('btn.common.save') }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" lg="6" class="pa-0 text-right pr-4">
              <v-btn class="btn btn-delete btn-popup" @click="removeDialog">
                <!-- <v-icon x-small class="mr-2">fas fa-times</v-icon> -->
                {{ $t('btn.common.close') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <dialogWindow
      ref="validateAddSQLGroup"
      :detail="validateAddMes"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialog"
      :detail="$t('msg.common.deleteConfirm')"
      :dataValue="deleteData"
      :showCancel="true"
      @select-ok="deleteSQLGroup($event)"
      color="information"
      size="max"
      title="confirmDialog"
    ></dialogWindow>
    <dialogWindow
      ref="confirmDeleteFileDialogEx"
      :detail="$t('msg.common.deleteConfirm')"
      :dataValue="deleteData"
      :showCancel="true"
      @select-ok="deleteSQLGroupEx($event)"
      color="information"
      size="max"
      title="confirmDialog"
    ></dialogWindow>
    <dialogWindow
      ref="warningDbType"
      :detail="warningDbTypeMes"
      :showCancel="false"
      color="validation"
      size="max"
      title="warning"
    ></dialogWindow>
    <dialogWindow
      ref="warningSaveSQLGroup"
      :detail="$t('msg.common.require', ['SQL Group Name'])"
      :showCancel="false"
      size="max"
      title="warning"
      color="validation"
      @select-ok="focusSQLGroupName($event)"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'add-code-group-dialog',
  props: {
    id: String,
    title: String,
    options: Object,
    eventCb: Function,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    selectFile: String,
    types: Array,
    agentId: String,
    targetAgentId: String,
  },
  components: {
    DialogDrag,
    dialogWindow,
    IconSvg,
  },
  data() {
    return {
      selectRadioItemEx: '',
      panelEx: [],
      executionResultList: [],
      executionTypeList: [
        { text: 'Done', value: 'END' },
        { text: 'Error', value: 'ERROR' },
      ],
      sqlGroupName: '',
      sqlGroupData: [],
      selectItemQuerySelect: [],
      selectItemQueryExecution: [],
      selectItemQueryDone: [],
      selectItemQueryError: [],
      selectedItemIndexSelect: '',
      selectedItemIndexExecution: '',
      selectedItemIndexDone: '',
      selectedItemIndexError: '',
      deleteData: '',
      selectMasterRows: [],
      sqlGroupQueryInfoList: [],
      checkedAll: false,
      searchCodeName: '',
      isDisabledAll: false,
      selectedRowLinked: '',
      sqlGroupDetailList: [],
      warningDbTypeMes: '',
      validateAddMes: '',
      searchBy: {
        sql_cnt_nm: '',
        sql_cnt_tp: '',
        sql_cnt: '',
      },
      addDataItems: {
        sql_grp_nm: '',
        sql_grp_id: '',
        sqlGroupQueryInfo: [],
      },
      headerSQLGroup: [
        { value: 'checkbox', text: '', width: '60px', class: 'checkbox-col' },
        {
          text: this.$t('tbl.datasource.addSqlGroupDialog.queryName'),
          value: 'sql_cnt_nm',
          width: '150px',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.addSqlGroupDialog.type'),
          value: 'sql_cnt_tp',
          width: '50px',
          align: 'center',
        },
        {
          text: this.$t('tbl.datasource.addSqlGroupDialog.queryText'),
          value: 'sql_cnt',
          width: '250px',
          align: 'center',
        },
      ],
      dbInsType: [],
      sourceDbInstanceList: [],
      targetDbInstanceList: [],
      srcTRG: [
        { value: 'S', text: 'SRC' },
        { value: 'T', text: 'TRG' },
      ],
      src: 'S',
      trg: 'T',
      selectRadioItem: '',
      panel: [],
      sqlGroupDataSelect: [],
      sqlGroupDataExecution: [],
      sqlGroupDataDone: [],
      sqlGroupDataError: [],
    };
  },
  computed: {
    isBtnActive() {
      return this.selectMasterRows.length > 0 &&
        (this.selectRadioItem !== '' || this.selectRadioItemEx !== '')
        ? false
        : true;
    },
    ...mapGetters(['dbInstanceList', 'dbInsTypeList']),
  },
  watch: {
    sqlGroupData() {
      if (this.sqlGroupData.length > 0) {
        let sql_cnt_tp = this.sqlGroupData[0].sql_cnt_tp;
        let sqlGroupQueryInfoList = this.sqlGroupQueryInfoList.filter(
          (item) => item.sql_cnt_tp === sql_cnt_tp
        );
        this.isDisabledAll =
          sqlGroupQueryInfoList.length === this.sqlGroupData.length ? true : false;
      }
    },
  },
  methods: {
    addExecutionResult() {
      const executionResult = {
        sql_func_type: '',
        seq: this.executionResultList.length,
        sqlGroupData: [],
        selectItemQuery: [],
        selectedItemIndex: [],
      };
      this.executionResultList.push(executionResult);
      this.onChangeSelectRadioExecution(executionResult.seq);
    },
    removeExecutionResult(index) {
      for (let i = 0; i < this.executionResultList.length; i++) {
        let executionResult = this.executionResultList[i];
        if (executionResult.seq > index) {
          executionResult.seq -= 1;
          this.executionResultList.splice(i, 1, executionResult);
        }
      }
      this.executionResultList.splice(index, 1);
    },
    saveSQLGroupName() {
      let validResult = this.$refs.form.validate();
      if (!validResult) {
        this.validateAddMes = this.$t('msg.dataSource.sqlGroup.warningValidateD2D');
        this.$refs.validateAddSQLGroup.dialog = true;
        return;
      } else if (this.sqlGroupDataSelect.length < 1 || this.sqlGroupDataExecution.length < 1) {
        this.validateAddMes = this.$t('msg.dataSource.sqlGroup.warningAddD2DSQLGroup');
        this.$refs.validateAddSQLGroup.dialog = true;
        return;
      } else if (this.sqlGroupName.trim() == '') {
        this.$refs.warningSaveSQLGroup.dialog = true;
      } else {
        this.addDataItems.sql_grp_nm = this.sqlGroupName;
        this.addDataItems.sql_grp_type = 'D';
        this.sqlGroupDataSelect.forEach((item, index) => {
          item.sql_func_type = 'BEGIN';
          item.sql_src_trg_flag = this.src;
          item.seq = index + 1;
        });
        this.sqlGroupDataExecution.forEach((item, index) => {
          item.sql_func_type = 'BODY';
          item.sql_src_trg_flag = this.trg;
          item.seq = index + 1;
        });
        this.sqlGroupDataDone.forEach((item, index) => {
          item.sql_func_type = 'END';
          item.seq = index + 1;
        });
        this.sqlGroupDataError.forEach((item, index) => {
          item.sql_func_type = 'ERROR';
          item.seq = index + 1;
        });

        this.sqlGroupData.push(...this.sqlGroupDataSelect);
        this.sqlGroupData.push(...this.sqlGroupDataExecution);
        this.sqlGroupData.push(...this.sqlGroupDataDone);
        this.sqlGroupData.push(...this.sqlGroupDataError);

        this.executionResultList.forEach((e, i) => {
          e.sqlGroupData.forEach((item, index) => {
            item.seq = index + 1;
            item.group_seq = i;
            item.sql_func_type = e.sql_func_type;
            item.sql_db_instance =
              this.dbInsType.find((e) => e.value === item.sql_db_instance)?.dbInstance || '';
          });
          this.sqlGroupData.push(...e.sqlGroupData);
        });
        // console.log("-------sqlGroupData-------", this.sqlGroupData)
        this.sqlGroupData.map((item, index) => {
          this.addDataItems.sqlGroupQueryInfo[index] = {
            sql_cnt_id: item.sql_cnt_id,
            sql_cnt: item.sql_cnt,
            sql_func_type: item.sql_func_type,
            sql_db_instance: item.sql_db_instance,
            sql_src_trg_flag: item.sql_src_trg_flag,
            seq: item.seq,
            group_seq: item.group_seq,
          };
        });
        if (this.options.item.action == 'add') {
          // console.log("----------------Add SQL Group----------", this.addDataItems)
          this.$store.dispatch('addSQLGroup', this.addDataItems).then(() => {
            this.refreshDialog({});
          });
        } else {
          this.addDataItems.sql_grp_id = this.options.item.selectedRow.sql_grp_id;
          // console.log("----------------Modify SQL Group----------", this.addDataItems)
          this.$store.dispatch('modifySQLGroup', this.addDataItems).then(() => {
            this.refreshDialog({});
          });
        }
      }
    },
    selectItemChange(event, item) {
      // console.log("click", item)
      let checked = item.checked;
      if (checked == true) {
        if (this.panel[0] === 0 || this.panel[0] === 1) {
          if (!this.validateDbNameAndType(item)) this.selectMasterRows.push(item);
        } else {
          this.selectMasterRows.push(item);
        }
      } else if (checked == false) {
        let index = this.findIndexItem(item, this.selectMasterRows, 'sql_cnt_id');
        // console.log("index", index)
        if (index != null) {
          this.selectMasterRows.splice(index, 1);
        }
      }
      // console.log("checked", this.selectMasterRows)
    },
    validateDbNameAndType(itemChecked) {
      // console.log("----------validateDbNameAndType------",itemChecked, selectMasterRows)
      let isValidate = false;
      if (this.panel[0] === 0 && itemChecked.sql_cnt_tp !== 'select') {
        this.$refs.warningDbType.dialog = true;
        this.warningDbTypeMes = this.$t('msg.dataSource.sqlGroup.warningDbTypeSelect');
        isValidate = true;
        itemChecked.checked = false;
        return isValidate;
      }
      if (this.panel[0] === 1 && itemChecked.sql_cnt_tp === 'select') {
        this.$refs.warningDbType.dialog = true;
        this.warningDbTypeMes = this.$t('msg.dataSource.sqlGroup.warningDbTypeEx');
        isValidate = true;
        itemChecked.checked = false;
        return isValidate;
      }
      return isValidate;
    },
    selectAllChange(value) {
      let sql_cnt_nm = this.sqlGroupData[0].sql_cnt_nm;
      let sql_cnt_tp = this.sqlGroupData[0].sql_cnt_tp;

      let selectAllItems = [];
      this.checkedAll = value;
      if (value) {
        this.sqlGroupQueryInfoList.map((item) => {
          if (item.sql_cnt_nm === sql_cnt_nm && item.sql_cnt_tp === sql_cnt_tp) {
            item.checked = value;
            selectAllItems.push(item);
          }
        });
        this.sqlGroupData.map((element) => {
          selectAllItems = selectAllItems.filter((item) => item.sql_cnt_id !== element.sql_cnt_id);
        });

        this.selectMasterRows = selectAllItems;
      } else {
        this.sqlGroupQueryInfoList.map((item) => {
          if (item.sql_cnt_nm === sql_cnt_nm && item.sql_cnt_tp === sql_cnt_tp) {
            selectAllItems.push(item);
          }
        });
        this.sqlGroupData.map((element) => {
          selectAllItems = selectAllItems.filter((item) => item.sql_cnt_id !== element.sql_cnt_id);
        });
        selectAllItems.map((item) => {
          item.checked = value;
        });
        this.selectMasterRows = [];
      }
    },
    getConvertQueryType(itemSQLGroup) {
      let convertType = '';
      let type = this.types.filter(
        (itemType) => itemType.value.toLowerCase() === itemSQLGroup.sql_cnt_tp
      );
      if (type[0]) {
        convertType = type[0].text;
      }
      return convertType;
    },
    reloadDbBrokerListDisabled() {
      let sqlGroupData = JSON.parse(
        JSON.stringify(this.sqlGroupData.concat(this.selectMasterRows))
      );
      sqlGroupData.map((item) => {
        let indexDisabled = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
        if (indexDisabled != null) {
          this.sqlGroupQueryInfoList[indexDisabled].disabled = true;
          this.sqlGroupQueryInfoList[indexDisabled].checked = true;
          this.sqlGroupQueryInfoList.splice(
            indexDisabled,
            1,
            this.sqlGroupQueryInfoList[indexDisabled]
          );
        }
      });
    },
    getSQLGroupQueryInfoList() {
      this.$store.dispatch('getSQLGroupQueryInfoList', this.searchBy).then(() => {
        this.sqlGroupQueryInfoList = this.$store.getters.sqlGroupQueryInfoList;
        // console.log("-------------Before getSQLGroupQueryInfoList-----------------", this.sqlGroupQueryInfoList);
        this.sqlGroupQueryInfoList.map((itemSQLGroup, index) => {
          let queryType = this.getConvertQueryType(itemSQLGroup);
          this.sqlGroupQueryInfoList[index].sql_cnt_tp = queryType;
          this.sqlGroupQueryInfoList[index].disabled = true;
        });
        // console.log("-------------After getSQLGroupQueryInfoList-----------------", this.sqlGroupQueryInfoList);
        this.reloadDbBrokerListDisabled();
      });
    },
    addSQLGroup() {
      if (this.selectRadioItem) {
        switch (this.selectRadioItem) {
          case 'Select (Source)':
            if (this.sqlGroupDataSelect.length < 1) {
              let element;
              for (let index = 0; index < this.selectMasterRows.length; index++) {
                element = this.selectMasterRows[index];
                this.sqlGroupDataSelect.push(element);
              }
            } else {
              this.sqlGroupDataSelect = this.sqlGroupDataSelect.concat(this.selectMasterRows);
            }
            this.sqlGroupDataSelect.map((item) => {
              let index = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
              if (index != null) {
                this.$nextTick(() => {
                  this.sqlGroupQueryInfoList[index].disabled = true;
                  this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
                });
              }
            });
            break;
          case 'Execution (Target)':
            if (this.sqlGroupDataExecution.length < 1) {
              let element;
              for (let index = 0; index < this.selectMasterRows.length; index++) {
                element = this.selectMasterRows[index];
                this.sqlGroupDataExecution.push(element);
              }
            } else {
              this.sqlGroupDataExecution = this.sqlGroupDataExecution.concat(this.selectMasterRows);
            }
            this.sqlGroupDataExecution.map((item) => {
              let index = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
              if (index != null) {
                this.$nextTick(() => {
                  this.sqlGroupQueryInfoList[index].disabled = true;
                  this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
                });
              }
            });
            break;
          case 'Done':
            if (this.sqlGroupDataDone.length < 1) {
              let element;
              for (let index = 0; index < this.selectMasterRows.length; index++) {
                element = this.selectMasterRows[index];
                this.sqlGroupDataDone.push(element);
              }
            } else {
              this.sqlGroupDataDone = this.sqlGroupDataDone.concat(this.selectMasterRows);
            }
            this.sqlGroupDataDone.map((item) => {
              let index = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
              if (index != null) {
                this.$nextTick(() => {
                  this.sqlGroupQueryInfoList[index].disabled = true;
                  this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
                });
              }
            });
            break;
          case 'Error':
            if (this.sqlGroupDataError.length < 1) {
              let element;
              for (let index = 0; index < this.selectMasterRows.length; index++) {
                element = this.selectMasterRows[index];
                this.sqlGroupDataError.push(element);
              }
            } else {
              this.sqlGroupDataError = this.sqlGroupDataError.concat(this.selectMasterRows);
            }
            this.sqlGroupDataError.map((item) => {
              let index = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
              if (index != null) {
                this.$nextTick(() => {
                  this.sqlGroupQueryInfoList[index].disabled = true;
                  this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
                });
              }
            });
        }
      } else if (this.selectRadioItemEx) {
        if (this.executionResultList[this.panelEx].sqlGroupData.length < 1) {
          let element;
          for (let index = 0; index < this.selectMasterRows.length; index++) {
            element = this.selectMasterRows[index];
            this.executionResultList[this.panelEx].sqlGroupData.push(element);
          }
        } else {
          this.executionResultList[this.panelEx].sqlGroupData = this.executionResultList[
            this.panelEx
          ].sqlGroupData.concat(this.selectMasterRows);
        }
        this.executionResultList[this.panelEx].sqlGroupData.map((item) => {
          let index = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
          if (index != null) {
            this.$nextTick(() => {
              this.sqlGroupQueryInfoList[index].disabled = true;
              this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
            });
          }
        });
      }
      this.checkedAll = false;
      this.selectMasterRows = [];
    },
    confirmDeleteItem(item) {
      this.deleteData = item;
      this.$refs.confirmDeleteFileDialog.dialog = true;
    },
    confirmDeleteItemEx(index, item) {
      this.deleteData = { index: index, item: item };
      this.$refs.confirmDeleteFileDialogEx.dialog = true;
    },
    deleteSQLGroup(item) {
      let indexDisabled = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
      let index = null;
      if (indexDisabled != null) {
        this.sqlGroupQueryInfoList[indexDisabled].disabled = false;
        this.sqlGroupQueryInfoList[indexDisabled].checked = false;
        this.sqlGroupQueryInfoList.splice(
          indexDisabled,
          1,
          this.sqlGroupQueryInfoList[indexDisabled]
        );
      }
      switch (this.selectRadioItem) {
        case 'Execution (Target)':
          index = this.findIndexItem(item, this.sqlGroupDataExecution, 'sql_cnt_id');
          if (index != null) {
            this.sqlGroupDataExecution.splice(index, 1);
          }
          break;
        case 'Done':
          index = this.findIndexItem(item, this.sqlGroupDataDone, 'sql_cnt_id');
          if (index != null) {
            this.sqlGroupDataDone.splice(index, 1);
          }
          break;
        case 'Error':
          index = this.findIndexItem(item, this.sqlGroupDataError, 'sql_cnt_id');
          if (index != null) {
            this.sqlGroupDataError.splice(index, 1);
          }
          break;
        default:
          index = this.findIndexItem(item, this.sqlGroupDataSelect, 'sql_cnt_id');
          if (index != null) {
            this.sqlGroupDataSelect.splice(index, 1);
          }
      }
    },
    deleteSQLGroupEx(data) {
      const index = data.index;
      const item = data.item;
      let indexDisabled = this.findIndexItem(item, this.sqlGroupQueryInfoList, 'sql_cnt_id');
      if (indexDisabled != null) {
        this.sqlGroupQueryInfoList[indexDisabled].disabled = false;
        this.sqlGroupQueryInfoList[indexDisabled].checked = false;
        this.sqlGroupQueryInfoList.splice(
          indexDisabled,
          1,
          this.sqlGroupQueryInfoList[indexDisabled]
        );
      }
      const indexFind = this.findIndexItem(
        item,
        this.executionResultList[index].sqlGroupData,
        'sql_cnt_id'
      );
      if (indexFind != null) {
        this.executionResultList[index].sqlGroupData.splice(indexFind, 1);
      }
    },
    selectItemQuery(item) {
      switch (this.selectRadioItem) {
        case 'Execution (Target)':
          if (this.selectItemQueryExecution.length > 0) {
            this.selectItemQueryExecution[0].sql_cnt_id !== item.sql_cnt_id
              ? this.selectItemQueryExecution.splice(0, 1, item)
              : this.selectItemQueryExecution.pop();
          } else {
            this.selectItemQueryExecution.push(item);
          }
          break;
        case 'Done':
          if (this.selectItemQueryDone.length > 0) {
            this.selectItemQueryDone[0].sql_cnt_id !== item.sql_cnt_id
              ? this.selectItemQueryDone.splice(0, 1, item)
              : this.selectItemQueryDone.pop();
          } else {
            this.selectItemQueryDone.push(item);
          }
          break;
        case 'Error':
          if (this.selectItemQueryError.length > 0) {
            this.selectItemQueryError[0].sql_cnt_id !== item.sql_cnt_id
              ? this.selectItemQueryError.splice(0, 1, item)
              : this.selectItemQueryError.pop();
          } else {
            this.selectItemQueryError.push(item);
          }
          break;
        default:
          if (this.selectItemQuerySelect.length > 0) {
            this.selectItemQuerySelect[0].sql_cnt_id !== item.sql_cnt_id
              ? this.selectItemQuerySelect.splice(0, 1, item)
              : this.selectItemQuerySelect.pop();
          } else {
            this.selectItemQuerySelect.push(item);
          }
      }
    },
    selectItemQueryEx(index, item) {
      if (this.executionResultList[index].selectItemQuery.length > 0) {
        this.executionResultList[index].selectItemQuery[0].sql_cnt_id !== item.sql_cnt_id
          ? this.executionResultList[index].selectItemQuery.splice(0, 1, item)
          : this.executionResultList[index].selectItemQuery.pop();
      } else {
        this.executionResultList[index].selectItemQuery.push(item);
      }
    },
    findIndexItem(item, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row[prop] === item[prop];
      });
      return index > -1 ? index : null;
    },
    swap(sqlGroupData, index1, index2) {
      var temp = sqlGroupData[index2];
      sqlGroupData.splice(index2, 1, sqlGroupData[index1]);
      sqlGroupData.splice(index1, 1, temp);
    },
    moveUpQuery() {
      let selectedItem = [];
      let index = null;
      switch (this.selectRadioItem) {
        case 'Execution (Target)':
          if (selectedItem) {
            selectedItem = this.selectItemQueryExecution[0];
            index = this.findIndexItem(selectedItem, this.sqlGroupDataExecution, 'sql_cnt_id');
            if (index != null && index > 0) {
              this.swap(this.sqlGroupDataExecution, index, index - 1);
              this.selectedItemIndexExecution = index - 1;
            }
          }
          break;
        case 'Done':
          if (selectedItem) {
            selectedItem = this.selectItemQueryDone[0];
            index = this.findIndexItem(selectedItem, this.sqlGroupDataDone, 'sql_cnt_id');
            if (index != null && index > 0) {
              this.swap(this.sqlGroupDataDone, index, index - 1);
              this.selectedItemIndexDone = index - 1;
            }
          }
          break;
        case 'Error':
          if (selectedItem) {
            selectedItem = this.selectItemQueryError[0];
            index = this.findIndexItem(selectedItem, this.sqlGroupDataError, 'sql_cnt_id');
            if (index != null && index > 0) {
              this.swap(this.sqlGroupDataError, index, index - 1);
              this.selectedItemIndexError = index - 1;
            }
          }
          break;
        default:
          if (selectedItem) {
            selectedItem = this.selectItemQuerySelect[0];
            index = this.findIndexItem(selectedItem, this.sqlGroupDataSelect, 'sql_cnt_id');
            if (index != null && index > 0) {
              this.swap(this.sqlGroupDataSelect, index, index - 1);
              this.selectedItemIndexSelect = index - 1;
            }
          }
      }
    },
    moveDownQuery() {
      let selectedItem = [];
      let index = null;
      let sqlGroupDataLength = null;
      switch (this.selectRadioItem) {
        case 'Execution (Target)':
          selectedItem = this.selectItemQueryExecution[0];
          sqlGroupDataLength = this.sqlGroupDataExecution.length;
          if (selectedItem) {
            index = this.findIndexItem(selectedItem, this.sqlGroupDataExecution, 'sql_cnt_id');
            if (index != null && index < sqlGroupDataLength - 1) {
              this.swap(this.sqlGroupDataExecution, index, index + 1);
              this.selectedItemIndexExecution = index + 1;
            }
          }
          break;
        case 'Done':
          selectedItem = this.selectItemQueryDone[0];
          sqlGroupDataLength = this.sqlGroupDataDone.length;
          if (selectedItem) {
            index = this.findIndexItem(selectedItem, this.sqlGroupDataDone, 'sql_cnt_id');
            if (index != null && index < sqlGroupDataLength - 1) {
              this.swap(this.sqlGroupDataDone, index, index + 1);
              this.selectedItemIndexDone = index + 1;
            }
          }
          break;
        case 'Error':
          selectedItem = this.selectItemQueryError[0];
          sqlGroupDataLength = this.sqlGroupDataError.length;
          if (selectedItem) {
            index = this.findIndexItem(selectedItem, this.sqlGroupDataError, 'sql_cnt_id');
            if (index != null && index < sqlGroupDataLength - 1) {
              this.swap(this.sqlGroupDataError, index, index + 1);
              this.selectedItemIndexError = index + 1;
            }
          }
          break;
        default:
          selectedItem = this.selectItemQuerySelect[0];
          sqlGroupDataLength = this.sqlGroupDataSelect.length;
          if (selectedItem) {
            index = this.findIndexItem(selectedItem, this.sqlGroupDataSelect, 'sql_cnt_id');
            if (index != null && index < sqlGroupDataLength - 1) {
              this.swap(this.sqlGroupDataSelect, index, index + 1);
              this.selectedItemIndexSelect = index + 1;
            }
          }
      }
    },
    moveDownQueryEx(index) {
      const selectedItem = this.executionResultList[index].selectItemQuery[0];
      const sqlGroupDataLength = this.executionResultList[index].sqlGroupData.length;
      if (selectedItem) {
        const indexFind = this.findIndexItem(
          selectedItem,
          this.executionResultList[index].sqlGroupData,
          'sql_cnt_id'
        );
        if (indexFind != null && indexFind < sqlGroupDataLength - 1) {
          this.swap(this.executionResultList[index].sqlGroupData, indexFind, indexFind + 1);
          this.executionResultList[index].selectedItemIndex = indexFind + 1;
        }
      }
    },
    moveUpQueryEx(index) {
      const selectedItem = this.executionResultList[index].selectItemQuery[0];
      const indexFind = this.findIndexItem(
        selectedItem,
        this.executionResultList[index].sqlGroupData,
        'sql_cnt_id'
      );
      if (indexFind != null && indexFind > 0) {
        this.swap(this.executionResultList[index].sqlGroupData, indexFind, indexFind - 1);
        this.executionResultList[index].selectedItemIndex = indexFind - 1;
      }
    },
    getSQLGroupDetail(sqlGroupId) {
      this.$store.dispatch('getSQLGroupD2DDetail', { sqlGroupId: sqlGroupId }).then(() => {
        this.sqlGroupDetailList = this.$store.getters.sqlGroupDetailList;
        // this.sqlGroupData = this.sqlGroupDetailList;
        this.sqlGroupDetailList.map((item, index) => {
          this.sqlGroupDetailList[index].sql_cnt_tp = this.getConvertQueryType(item);
          if (this.sqlGroupDetailList[index].sql_func_type === 'BEGIN')
            this.sqlGroupDataSelect.push(this.sqlGroupDetailList[index]);
          if (this.sqlGroupDetailList[index].sql_func_type === 'BODY')
            this.sqlGroupDataExecution.push(this.sqlGroupDetailList[index]);
          if (this.sqlGroupDetailList[index].sql_func_type === 'END')
            this.sqlGroupDataDone.push(this.sqlGroupDetailList[index]);
          if (this.sqlGroupDetailList[index].sql_func_type === 'ERROR')
            this.sqlGroupDataError.push(this.sqlGroupDetailList[index]);
        });
        // console.log("-------------getSQLGroupDetail-----------------", this.sqlGroupDetailList);
      });
      this.checkStatusItem();
    },
    checkStatusItem() {
      // console.log('this.sqlGroupDataExecution',this.sqlGroupDataExecution)
      this.sqlGroupQueryInfoList.map((item, index) => {
        let indexDisabled;
        if (this.panel[0] === 0) {
          indexDisabled = this.findIndexItem(item, this.sqlGroupDataSelect, 'sql_cnt_id');
        } else if (this.panel[0] === 1) {
          indexDisabled = this.findIndexItem(item, this.sqlGroupDataExecution, 'sql_cnt_id');
        } else if (this.panel[0] === 2) {
          indexDisabled = this.findIndexItem(item, this.sqlGroupDataDone, 'sql_cnt_id');
        } else if (this.panel[0] === 3) {
          indexDisabled = this.findIndexItem(item, this.sqlGroupDataError, 'sql_cnt_id');
        }
        this.sqlGroupQueryInfoList[index].disabled = false;
        this.sqlGroupQueryInfoList[index].checked = false;
        this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
        if (indexDisabled != null) {
          this.sqlGroupQueryInfoList[index].disabled = true;
          this.sqlGroupQueryInfoList[index].checked = true;
          this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
        }
      });
    },
    checkStatusItemEx(i) {
      // console.log('this.sqlGroupDataExecution',this.sqlGroupDataExecution)
      this.sqlGroupQueryInfoList.map((item, index) => {
        let indexDisabled;

        if (this.executionResultList[i].sql_func_type) {
          indexDisabled = this.findIndexItem(
            item,
            this.executionResultList[i].sqlGroupData,
            'sql_cnt_id'
          );
          this.sqlGroupQueryInfoList[index].disabled = false;
          this.sqlGroupQueryInfoList[index].checked = false;
          this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
          if (indexDisabled != null) {
            this.sqlGroupQueryInfoList[index].disabled = true;
            this.sqlGroupQueryInfoList[index].checked = true;
            this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
          }
        } else {
          this.sqlGroupQueryInfoList[index].disabled = true;
          this.sqlGroupQueryInfoList[index].checked = true;
          this.sqlGroupQueryInfoList.splice(index, 1, this.sqlGroupQueryInfoList[index]);
        }
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      // this.closeDialog(dialog);
      EventBus.$emit('remove-dialog-add', dialog);
    },
    refreshDialog(dialog) {
      dialog.id = this.id;
      EventBus.$emit('refeshListSQLManage');
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
    focusSQLGroupName() {
      this.setFocus();
    },
    setFocus() {
      setTimeout(() => {
        this.$refs.sqlGroupName.focus();
      }, 300);
    },
    onChangeSelectRadio(e) {
      this.panelEx = [];
      this.selectRadioItemEx = '';
      this.selectRadioItem = e;
      switch (this.selectRadioItem) {
        case 'Execution (Target)':
          this.panel.splice(0, 1);
          this.panel.push(1);
          break;
        case 'Done':
          this.panel.splice(0, 1);
          this.panel.push(2);
          break;
        case 'Error':
          this.panel.splice(0, 1);
          this.panel.push(3);
          break;
        case 'Select (Source)':
          this.panel.splice(0, 1);
          this.panel.push(0);
          break;
        default:
          this.panel = [];
      }
      this.checkStatusItem();
    },
    onChangeSelectRadioExecution(index) {
      this.selectRadioItemEx = this.executionResultList[index].sql_func_type;
      this.panel = [];
      this.selectRadioItem = '';
      this.panelEx.splice(0, 1);
      this.panelEx.push(index);

      this.checkStatusItemEx(index);
    },
  },
  created() {
    this.getSQLGroupQueryInfoList();
    this.setFocus();
    if (this.options.item.action == 'modify') {
      this.getSQLGroupDetail(this.options.item.selectedRow.sql_grp_id);
      this.sqlGroupName = this.options.item.selectedRow.sql_grp_nm;
    }
    this.$store.dispatch('getDbAgentList').then(() => {
      this.dbInsType = this.dbInsTypeList;
    });

    if (this.agentId) {
      this.$store
        .dispatch('getDbAgentListByAgent', { agent_id: this.agentId })
        .then(() => {
          this.sourceDbInstanceList = this.dbInstanceList;
        })
        .then(() => {
          if (this.targetAgentId) {
            this.$store
              .dispatch('getDbAgentListByAgent', { agent_id: this.targetAgentId })
              .then(() => {
                this.targetDbInstanceList = this.dbInstanceList;
              });
          }
        });
    }
  },
};
</script>

<style>
.db-adapter-builder .maplist-layout-dialog .v-input.label-peer-text3 {
  margin-top: 0px;
}
.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text3
  .v-input__control
  .v-input__slot
  .v-select__slot {
  height: 28px !important;
}
.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text3
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-label--active {
  top: 26px !important;
  left: 13px !important;
  color: gray !important;
}

.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text3
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-select__selections {
  margin-left: 50px !important;
  padding-top: 0px !important;
}

.db-adapter-builder
  .maplist-layout-dialog
  .v-input.label-peer-text3
  .v-input__control
  .v-input__slot
  .v-select__slot
  .v-input__append-inner {
  margin-top: 1px !important;
}
</style>
